import moment from 'moment';
import { getActualDepartureCars, getPlanDepartureCars, crudRequest } from '@/services/api';
import { getToDay } from '@/utils/date';

const [startDate, endDate] = getToDay();
const paramsForm = {
  dateRange: [startDate.clone(), endDate.clone()],
  crrentDateRange: '',
  centerFilter: '',
  access: '',
  searchParams: {
    departProvinceArea: '',
    arrivalProvinceArea: '',
    departCenter: '',
    startDate: startDate.clone().format('YYYY-MM-DD HH:mm'),
    endDate: endDate.clone().format('YYYY-MM-DD HH:mm'),
  },
  centerCode: '',
};

export default {
  namespace: 'centerWeightView2Test2',
  state: {
    ...paramsForm,
    defualtDateFormat: 'YYYY-MM-DD HH:mm:00',
    onSearch: false,
    tableOffsetHeight: 0,
    datadbName: 'druid',

    dayAggChange: true, // true为按天统计表

    isTmsLoading: false, // tms 接口是否加载完成
    actualDepartureCarsItem: [], // 已发出 tms
    planDepartureCarsItem: [], // 计划发
    volumeItem: [], // 运力
    actualVolumeList: [], // 实际运力
  },
  effects: {
    *getSelect({ payload }, { put }) {
      yield put({
        type: 'update',
        payload: { ...payload },
      });
      crudRequest('/api/route/centerweightview/search');
      yield put({ type: 'centerWeightViewDepartTablesTest2/getSelect' });
    },
    *getTms({ payload }, { call, put, select }) {
      // tms
      yield put({ type: 'update', payload: { isTmsLoading: false } });
      let query = yield select(({ centerWeightView2Test2 }) => {
        return {
          searchParams: centerWeightView2Test2.searchParams,
          startTime: moment(centerWeightView2Test2.dateRange[0]).format(
            centerWeightView2Test2.defualtDateFormat,
          ),
          endTime: moment(centerWeightView2Test2.dateRange[1]).format(
            centerWeightView2Test2.defualtDateFormat,
          ),
        };
      });
      let access = yield select(({ centerWeightView2Test2 }) => {
        return centerWeightView2Test2?.access;
      });
      const start = moment(query.startTime).day();
      const volumes = yield crudRequest('/api/route/volumes', {
        // startTime: query.startTime,
        // endTime: query.endTime,
        period: start === 0 ? 7 : start,
        departureCenter: query.searchParams.departCenter?.name,
        departureProvinceArea: access.isArea
          ? query.searchParams.departProvinceAreaSelect?.label
          : query.searchParams.departProvinceArea?.name,
        arrivalProvinceArea: query.searchParams.arrivalProvinceArea?.name,
      });
      const actualVolumes = yield crudRequest('/api/route/volumes3', {
        startTime: query.startTime,
        endTime: query.endTime,
        departureCenter: query.searchParams.departCenter?.name,
        departureProvinceArea: access.isArea
          ? query.searchParams.departProvinceAreaSelect?.label
          : query.searchParams.departProvinceArea?.name,
        arrivalProvinceArea: query.searchParams.arrivalProvinceArea?.name,
      });
      const volumeItem = volumes.data && volumes.data.length > 0 ? volumes.data : [];
      const actualVolumeList =
        actualVolumes.data && actualVolumes.data.length > 0 ? actualVolumes.data : [];
      yield put({
        type: 'update',
        payload: {
          isTmsLoading: true,
          volumeItem: volumeItem,
          actualVolumeList,
        },
      });
    },
    *getTmsData({ payload: { scanSite } }, { call, put, select }) {
      let { dateRange } = yield select(({ centerWeightView2Test2 }) => centerWeightView2Test2);
      const result3 = yield call(getActualDepartureCars, {
        startTime: moment(dateRange[0]).format('YYYY-MM-DD 12:mm:00'),
        endTime: moment(dateRange[1]).format('YYYY-MM-DD 12:mm:00'),
        locationCode: scanSite,
      });

      const result4 = yield call(getPlanDepartureCars, {
        startTime: moment(dateRange[0]).format('YYYY-MM-DD 12:mm:00'),
        endTime: moment(dateRange[1]).add(1, 'day').format('YYYY-MM-DD 12:mm:00'),
        locationCode: scanSite,
      });
      return {
        actualDepartureCarsItem: result3.data || [],
        planDepartureCarsItem: result4.data || [],
      };
    },
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
    updateSearchParams(state, { payload }) {
      return { ...state, searchParams: { ...state.searchParams, ...payload } };
    },
  },
};

// 排除文件 CenterArrivalBoard,mock,CenterDepartBoard,ForecastCenterDepartBoard,centerMassageMap
